module.exports = __webpack_public_path__ + "static/media/message-circle.36c2888c.svg";